class ResponsiveTablesLight {
  constructor(config = {}) {
    const {
      tableComponentSelector,
      tableContainerSelector,
      tableSelector
    } = config;

    this.tables = document.querySelectorAll(tableSelector);
    this.tablesArray = Array.from(this.tables);

    if (this.tables) {
      this.tablesArray.forEach(table => {
        let container = table.closest(tableContainerSelector);
        let component = table.closest(tableComponentSelector);

        if (component && container) {
          this.toggleResponsiveTableClasses(component, container, table);

          if (component.classList.contains('responsive-table-alternative')) {
            this.enableDragScroll(container);
          }
        }
      });
    }

  }

  toggleResponsiveTableClasses(component, container, table) {
    if(this.hasHorizontalScrollbar(container, table) === true && this.hasRowSpan() === false) {
      component.classList.add('has-shadow', 'responsive-table');
    } else if(this.hasHorizontalScrollbar(container, table) === true && this.hasRowSpan() === true) {
      component.classList.add('responsive-table-alternative');
    } else {
      component.classList.remove('has-shadow', 'responsive-table', 'responsive-table-alternative');
    }

    window.addEventListener('resize', () => {
      if(this.hasHorizontalScrollbar(container, table) === true && this.hasRowSpan() === false) {
        component.classList.add('has-shadow', 'responsive-table');
      } else if(this.hasHorizontalScrollbar(container, table) === true && this.hasRowSpan() === true) {
        component.classList.add('responsive-table-alternative');
      } else {
        component.classList.remove('has-shadow', 'responsive-table', 'responsive-table-alternative');
      }
    });
  }

  hasHorizontalScrollbar(container, table) {
    const containerWidth = container.clientWidth;
    const tableWidth = table.clientWidth;

    return tableWidth > containerWidth;
  }

  hasRowSpan() {
    const tableCells = document.querySelectorAll('.lc-component--table table td[rowspan]');
    const tableCellsArray = Array.prototype.slice.call(tableCells);

    if (tableCellsArray.length > 0) {
      return true;
    } else {
      return false;
    }
  }


  enableDragScroll(container) {
    let isDragging = false;
    let startX;
    let scrollLeft;

    container.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
      container.classList.add('dragging');
    });

    container.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2; // Adjust speed
      container.scrollLeft = scrollLeft - walk;
    });

    container.addEventListener('mouseup', () => {
      isDragging = false;
      container.classList.remove('dragging');
    });

    container.addEventListener('mouseleave', () => {
      isDragging = false;
      container.classList.remove('dragging');
    });
  }
}

export default ResponsiveTablesLight;
